<template>
    <div>
        <b-card class="mb-3 shadow" :title="$t(`settings.card_contractconfidentialities`)">
            <b-button class="button-margin" variant="primary" @click.prevent="showNewItemForm" v-if="hasRole('Administrator')||hasRole('Berater')"><b-icon icon="folder-plus" />{{ $t("settings.new") }}</b-button>
            <br />
            <div class="table-scrollable">
                <b-table striped hover :items="contractConfidentialities" :fields="contractconfidentialityfields">
                    <template #cell(actions)="data">
                        <b-link class="m-1" href="#" v-show="data.index > 0" @click="moveItemUp(data.item.id)"><b-icon icon="chevron-up" scale="1.2"></b-icon></b-link>
                        <b-link class="m-1" href="#" v-show="data.index < contractConfidentialities.length-1" @click="moveItemDown(data.item.id)"><b-icon icon="chevron-down" scale="1.2"></b-icon></b-link>
                        <b-link class="m-1" href="#" @click="editItem(data.item)" v-if="hasRole('Administrator')||hasRole('Berater')"><b-icon icon="pencil-square" scale="1.2"></b-icon></b-link>
                        <b-link class="m-1" href="#" @click="requestConfirmation(data.item)" v-if="hasRole('Administrator')||hasRole('Berater')"><b-icon icon="trash" scale="1.2"></b-icon></b-link>
                    </template>
                </b-table>
            </div>
            <br />
            <b-modal ref="confirmationModal" hide-footer :title="$t(`settings.modal_title_delete`)">
                <div class="d-block text-center">
                    <p v-if="itemContext">{{ $t(`settings.delete_message`) }}</p>
                </div>
                <b-button class="button-margin mt-3" variant="outline-danger" block @click="executeDelete"><b-icon icon="trash" />{{ $t("settings.btn_delete") }}</b-button>
            </b-modal>
        </b-card>
        <EditContractConfidentiality ref="EditContractConfidentiality" :savedCallback="reload" />
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import EditContractConfidentiality from './EditContractConfidentiality';
    import ContractService from '../../../../../services/ContractService';

    export default {
        name: 'contractconfidentialities',
        components: {EditContractConfidentiality},
        props: [],
        data() {
            return {
                itemContext: null,
                currentItem: {}
            }
        },
        created() {
            this.fetchContractConfidentialities();
        },
        methods: {
            ...mapActions({
                fetchContractConfidentialities: 'contracts/fetchContractConfidentialities',
                deleteContractConfidentialities: 'contracts/deleteContractConfidentialities'
            }),
            showNewItemForm() {
                this.currentItemEditMode = false;
                this.$refs.EditContractConfidentiality.setItem({});
                this.$refs.EditContractConfidentiality.showModal();
            },
            editItem(item) {
                this.$refs.EditContractConfidentiality.setItem(item);
                this.$refs.EditContractConfidentiality.showModal();
                this.$refs.EditContractConfidentiality.enterEditMode();
            },
            requestConfirmation(item) {
                this.itemContext = item;
                this.$refs.confirmationModal.show();
            },
            executeDelete() {
                this.$refs.confirmationModal.hide();
                this.$store.commit('loading/setLoading', true);
                ContractService.deleteContractConfidentiality(this.itemContext.id)
                    .then(response => {
                        this.$store.commit('loading/setLoading', false);
                        if(!response.data.success) {
                            this.$notify({
                                group: 'global',
                                title: 'Fehler beim Entfernen der Vertraulichkeit.',
                                type: 'error',
                                text: response.data.message
                            });
                        }

                        this.itemContext = null;
                        this.reload();
                    });
            },
            reload() {
                this.fetchContractConfidentialities();
            },
            moveItemUp(contractconfidentialityId) {
                this.$store.commit('loading/setLoading', true);
                ContractService.moveContractConfidentialityUp(contractconfidentialityId)
                    .then(response => {
                        this.$store.commit('loading/setLoading', false);
                        this.fetchContractConfidentialities();
                    });
            },
            moveItemDown(contractconfidentialityId) {
                this.$store.commit('loading/setLoading', true);
                ContractService.moveContractConfidentialityDown(contractconfidentialityId)
                    .then(response => {
                        this.$store.commit('loading/setLoading', false);
                        this.fetchContractConfidentialities();
                    });
            }
        },
        computed: {
            ...mapGetters({
                hasRole: 'auth/hasRole',
                contractConfidentialities: 'contracts/contractConfidentialities'
            }),
            contractconfidentialityfields() {
                return [
                    { key: 'id',                                label: 'ID'                      },
                    { key: 'order',                             label: 'Reihenfolge'             },
                    { key: 'contract_confidentiality',          label: 'Vertraulichkeit'         },
                    { key: 'actions',                           label: 'Aktionen'                },
                ];
            },
        }
    }
</script>